export const searchProps = (state) => state.accrualReport.filter
export const accruals = (state) => state.accrualReport.accruals
